<!-- This component displays a list item with a folder and further meta data like date read, date updated.  -->
<!-- Details can be displayed by a LONG-CLICK and slide in                                                    -->
<!-- Favorites can be set/unset. An unread item is marked in bold text with an additional badge               -->
<template>
  <list-item
    :title="folder.name"
    :hasBadge="hasBadge"
    :badgeNumber="(folder._unreadCount || 0) + (folder._acknowledgeCount || 0)"
    :badgeColor="theme.unreadBadgeColor"
    itemIcon="mdi-folder"
    :iconColor="mx_listIconColor"
    :isUnreadCountFeatureEnabled="isUnreadCountFeatureEnabled"
    @onItemSelected="onFolderSelected"
  >
    <template v-slot:content>
      <n-list-subtitle v-if="folder.children && folder.children.length > 0">{{ folder.children.length }} direkte Ordner oder Dokumente</n-list-subtitle>
      <n-list-subtitle v-else>leerer Ordner</n-list-subtitle>
      <n-list-subtitle :class="`one-line${xs ? '' : '-smAndUp'}`" v-if="folder._unreadCount + folder._acknowledgeCount > 0">{{ counterText }} </n-list-subtitle>
    </template>
  </list-item>
</template>

<script>
import NListSubtitle from '@/components/texts/NListSubtitle.vue';
import ListItem from '@/components/listItems/ListItem';
import common from '@/mixins/common';
import dateTimeMixin from '@/mixins/dateTimeMixin';

export default {
  name: 'Folder',
  mixins: [common, dateTimeMixin],
  components: {
    NListSubtitle,
    ListItem,
  },

  props: {
    folder: {
      type: Object,
    },
    isUnreadCountFeatureEnabled: {
      type: Boolean,
      default: true,
    },
  },
  // created() {
  //   let { name, _acknowledgeCount, _unreadCount, _itemsWithExpectedLabels } = this.folder;
  //   console.debug('folder', JSON.stringify({ name, _acknowledgeCount, _unreadCount, _itemsWithExpectedLabels }));
  // },
  computed: {
    hasBadge() {
      return this.folder._unreadCount > 0;
    },
    counterText() {
      let text = '';
      let folder = this.folder;
      if (folder._unreadCount === 1) {
        text += this.$t('oneUnreadDoc');
      } else if (folder._unreadCount > 1) {
        text += this.$t('unreadDocuments', { count: folder._unreadCount });
      }
      if (folder._acknowledgeCount === 1) {
        text += (text.length > 0 ? ', ' : '') + this.$t('oneDocToAcknowledge');
      } else if (folder._acknowledgeCount > 1) {
        text += (text.length > 0 ? ', ' : '') + this.$t('toAcknowledgeCount', { count: folder._acknowledgeCount });
      }
      return text;
    },
  },

  methods: {
    onFolderSelected() {
      this.$emit('onSelected', this.folder);
    },
    isFavorite(file) {
      return file._userState && file._userState.favorite === 1;
    },
  },
};
</script>
<style scoped>
.one-line,
.one-line-smAndUp {
  text-overflow: ellipsis;
  white-space: nowrap;
}
.one-line {
  width: calc(100% - 30px);
}
s .one-line-smAndUp {
  width: 100%;
}
</style>
